import React from 'react'
import FormInput from '../../../../library/form/components/FormInput';
import FormLabel from '../../../../library/form/components/FormLabel';

const CmnMetalSearch = (props) => {
    const {rowKey, itemParam, qualityParam, formObject } = props;

    return (
        <>
            <span className="uiLblInLine">
                <FormLabel formObject={formObject} rowKey={rowKey || ""} action={{ paramName: itemParam || "item" }} value="Metal" />
            </span>
            <FormInput formObject={formObject} rowKey={rowKey || ""} className="uiInput" style={{width:'130px'}}
                placeholder="Item Name..."
                action={{ InputType: "ac", paramName: itemParam || "item", acMethod: "Item", acDepCtrl: { dtid: '%dataList.valLDT', level: '%dataList.level' } ,
                actionId: "refresh", actionParam: {changeitem:1} }} />
            <FormInput formObject={formObject} rowKey={rowKey || ""} className="uiInput" style={{width:'70px'}}
                placeholder="Quality..."
                action={{ InputType: "ac", paramName: qualityParam || "attrQuality", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' },
                actionId: "refresh", actionParam: {changeitem:1} }} />
        </>
    )
}

export default CmnMetalSearch;
